'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var toISOMonthString = {};

exports.__exports = toISOMonthString;
